import * as React from "react";
import { FC } from "react";
import * as styles from "./TransformGroup.less";

type Props = {
    rotation: "rotate90deg" | "reverse" | "rotate270deg" | "spinner";
};

export const TransformGroup: FC<Props> = ({ children, rotation }) => <g className={styles[rotation]}>{children}</g>;
